<template>
	<div class="">
		<div class="commonInfo-box">
			<div class="commonInfo-title">
				<div class="title-des">{{title || '基本信息'}}</div>
				<div class="title-switch" :class="switchState ? '' :'close'" @click=""></div>
			</div>
			<div class="commonInfo-list" v-if="switchState">
				<div class="commonInfo-item">
					<!-- <div class="commonInfo-des">{{item.name}}：</div> -->
					<el-form ref="ruleForm" class="demo-ruleForm" label-width="160px" :rules="rules" :model="data">
						<el-form-item :label="item.label || ''" :prop="item.value" v-for="item in fieldList" :key='item.value'>
							<!-- 普通输入框 -->
							<el-input v-if="item.type === 'input'" v-model="data[item.value]" :type='item.inputType'
							 clearable :disabled="item.disabled"  :placeholder="getPlaceholder(item)" @focus="handleEvent(item)" />
							 <!-- 小数点输入框 -->
							 <el-input v-if="item.type === 'number'" v-model="data[item.value]"  onKeyUp="value=value.replace(/[^0-9.]/g,'')"
							  clearable :disabled="item.disabled"  :placeholder="getPlaceholder(item)" @focus="handleEvent(item)" />
							<!-- 文本输入框 -->
							<el-input v-if="item.type === 'textarea'" v-model.trim="data[item.value]" :type="item.type" :maxlength="item.maxlength"
							 show-word-limit clearable :disabled="item.disabled" :placeholder="getPlaceholder(item)" :autosize="item.autosize || {minRows: 3, maxRows: 10}"
							 @focus="handleEvent(item)" />
							<!-- 计数器 -->
							<el-input-number v-if="item.type === 'inputNumber'" :disabled="item.disabled" v-model="data[item.value]" size="small" :min="item.min" :max="item.max"
							 controls-position="right" @change="handleEvent(item)" />
							<!-- 选择框 -->
							<el-select v-if="item.type === 'select'" v-model="data[item.value]" :disabled="item.disabled" clearable
							 :filterable="item.filterable" :placeholder="getPlaceholder(item)" @change="handleEvent(item,$event, data[item.value])">
								<el-option v-for="(item2, index) in item.options"
								 :label="item.porpLabel ? item2[item.porpLabel] : item2.label"
								 :value="item.porpValue ? item2[item.porpValue] : item2.value" 
								 :key="index" />
							</el-select>
							<!-- 联想选择框 -->
							<el-select v-if="item.type === 'select2'" :disabled="item.disabled" v-model="data[item.value]"  clearable @change="handleEvent(item,$event, data[item.value])"
							  :placeholder="getPlaceholder(item)" filterable remote :remote-method="(query)=>{remoteMethod(query,item)}">
								<el-option v-for="(item2, index) in item.options"
								 :label="item.porpLabel ? item2[item.porpLabel] : item2.label"
								 :value="item.porpValue ? item2[item.porpValue] : item2.value" 
								 :key="index" />
							</el-select>
							<!-- 单选框 -->
							<el-radio-group v-if="item.type === 'radio'" v-model="data[item.value]" :disabled="item.disabled" :placeholder="getPlaceholder(item)"
							 @change="handleEvent(item, data[item.value])">
								<el-radio-button v-for="(childItem, childIndex) in item.options" :key="childIndex" :label="childItem.value">{{childItem.label}}</el-radio-button>
							</el-radio-group>
							<!-- 多选框 -->
							<el-checkbox-group :disabled="item.disabled" v-if="item.type === 'check'" v-model="data[item.value]">
								<el-checkbox v-for="item2 in item.options" :label="item2.value" :key="item2.value">{{item2.label}}</el-checkbox>
							  </el-checkbox-group>
							<!-- 日期选择框 -->
							<el-date-picker v-if="item.type === 'date'" v-model="data[item.value]" :type="item.dateType" :picker-options="datePickerOptions[item.pickerOptions]"
							 clearable :disabled="item.disabled" :default-time="item.defaultTime" :placeholder="getPlaceholder(item)" @focus="handleEvent(item)"
							 start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" value-format="yyyy-MM-dd" />
							 <!-- 省市区选择 -->
							 <el-cascader
								:disabled="item.disabled"
								v-if="item.type === 'city'"
								 v-model="data[item.value]"
								 :options="cityInfo"
								 :props="cityProps"
								 @change="handleEvent(item,$event)">
							 </el-cascader>
							 <!-- 省市区选择 -->
							 <el-cascader
								:disabled="item.disabled"
								v-if="item.type === 'city2'"
								 v-model="data[item.value]"
								 :options="cityInfo3"
								 :props="cityProps"
								 @change="handleEvent(item,$event)">
							 </el-cascader>
							<!-- 标题 -->
							<div v-if="item.type == 'title'" style="font-weight: bold;font-size: 16px;">{{item.titleLabel}}</div>
							<!-- 内容 -->
							<div v-if="item.type == 'word'">{{item.word}}</div>
							<!-- 上传 -->
							<el-upload
							  v-if="item.type == 'upload'"
							  action="http://118.31.52.107:8521/api/upload-local"
							  :on-success='handleSuccess'
							  multiple
							  :file-list="data[item.value]">
							  <el-button size="small" type="primary" v-if="orderType != 1" @click="choiceItem = item">点击上传</el-button>
							</el-upload>
							<!-- 表格 -->
							<template v-if="item.type == 'table'">
								<el-table :data='item.tableData' border :row-class-name="tableRowClassName">
									<el-table-column :label="item2.label" v-for="(item2,index) in item.tableOption" :key="index">
										<template slot="header" slot-scope="scope">
											<i class="common-tag" v-if="item2.tag">*</i>
											{{item2.label}}
										</template>
										<template slot-scope="scope">
											<template v-if="orderType != 1">
												<el-input v-if="item2.type == 'input'" :placeholder="getPlaceholder(item2)" v-model="scope.row[item2.key]" />
												<!-- 选择框 -->
												<el-select v-if="item2.type === 'select'" v-model="scope.row[item2.key]"  clearable
												  :placeholder="getPlaceholder(item2)">
													<el-option v-for="(item3, index2) in item2.options"
													 :label="item.porpLabel ? item3[item.porpLabel] : item3.label"
													 :value="item.porpValue ? item3[item.porpValue] : item3.value"
													  :key="index2"
													 />
												</el-select>
												<!-- 选择框 -->
												<el-select v-if="item2.type === 'select2'" v-model="scope.row[item2.key]"  clearable
												  :placeholder="getPlaceholder(item2)" filterable remote :remote-method="(query)=>{remoteMethod(query,scope.row)}">
													<el-option v-for="(item3, index2) in item2.options"
													 :label="item.porpLabel ? item3[item.porpLabel] : item3.code"
													 :value="item.porpValue ? item3[item.porpValue] : item3.code" 
													 :key="index2"
													 />
												</el-select>
												<!-- 日期选择框 -->
												<el-date-picker v-if="item2.type === 'date'" v-model="scope.row[item2.key]" :type="item2.dateType" :picker-options="datePickerOptions[item2.pickerOptions]"
												 clearable :disabled="item2.disabled" :default-time="item2.defaultTime" :placeholder="getPlaceholder(item)" @focus="handleEvent(item)"
												 start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" value-format="yyyy-MM-dd" />
												 <!-- 小数点输入框 -->
												 <el-input v-if="item2.type === 'number'" v-model="scope.row[item2.key]"  onKeyUp="value=value.replace(/[^0-9.]/g,'')"
												  clearable :disabled="item2.disabled"  :placeholder="getPlaceholder(item2)" @focus="handleEvent(item2)" />
											</template>
											<template v-else>
												<div>{{scope.row[item2.key]}}</div>
											</template>
										</template>
									</el-table-column>
									<el-table-column label="操作" width="100">
										<template slot-scope="scope">
											<el-button @click="del(scope.row,item)"  size="small">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-button v-if="orderType != 1" plain @click="addTable(item)">添加</el-button>
							</template>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div style="margin-top: 20px;">
				<el-button type="primary" v-if="orderType != 1" @click="submitForm('ruleForm',1)">提交备案</el-button>
				<el-button type="primary" v-if="orderType != 1" @click="submitForm('ruleForm',0)">暂存草稿</el-button>
				<el-button type="primary" @click="back">返回</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: '',
			data: '',
			fieldList: '',
			rules: '',
			orderType : ''
		},
		watch: {
			fieldList(newValue){
				console.log(this.orderType,11)
			}
		},
		data() {
			return {
				choiceItem : {},
				cityProps : {
					value : 'label',
				},
				cityInfo : this.cityInfo,
				cityInfo3 : [],
				datePickerOptions: {
					// 不能选择当前之前的时间
					disabledCurrentBefore: {
						disabledDate(time) {
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
							return time.getTime() < start.getTime()
						}
					}
				},
				switchState: true
			}
		},
		methods: {
			remoteMethod(query,item){
				console.log(query,item)
				let obj = {
					query : query,
					item : item
				}
				if (query !== '') {
					this.loading = true;
					setTimeout(() => {
						this.loading = false;
						// this.options = this.list.filter(item => {
						// 	return item.label.toLowerCase()
						// 		.indexOf(query.toLowerCase()) > -1;
						// });
						this.$emit('searchOptions',obj)
					}, 200);
				} else {
					this.options = [];
				}
			},
			tableRowClassName({ row, rowIndex }) {
			    row.index = rowIndex;
			},
			del(row,node) {
				if(node.value == 'sellTargetList'){
					let needIndex = this.fieldList.findIndex(item=>item.value == 'sellTargetList')
					this.fieldList[needIndex].tableData.splice(row.index,1)
				}
				if(node.value == 'turningList'){
					let needIndex = this.fieldList.findIndex(item=>item.value == 'turningList')
					this.fieldList[needIndex].tableData.splice(row.index,1)
				}
			},
			handleSuccess(e,item){
				this.data[this.choiceItem.value].push(e)
			},
			addTable(node){
				let obj = {}
				if(node.value == 'sellTargetList'){
					obj = {
						name : '',
						assessPrice : '',
						bookNetValue : '',
						assetsType : '',
						remark : '',
						dealName : '',
						price : '',
						dealDate : '',
						assetsTypeStr : ''
					}
				}
				if(node.value == 'turningList'){
					obj = {
						date: '',
						measures: '',
						suggest: '',
					}
				}
				let needIndex = this.fieldList.findIndex(item=>item.value == node.value)
				this.fieldList[needIndex].tableData.push(obj)
			},
			back(){
				this.$emit('back')
			},
			getKeyUp(e,item){
				// value=value.replace(/[^0-9.]/g,'')
				console.log(e,item)
			},
			submitForm(formName,type) {
				console.log(this.data)
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$emit('confirm',type)
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			getPlaceholder(row) {
				let placeholder
				if(row.placeLabel){
					placeholder = row.placeLabel
				}else{
					if (row.type === 'input' || row.type === 'textarea') {
						placeholder = '请输入' + row.label
					} else if (row.type === 'select' || row.type === 'time' || row.type === 'date') {
						placeholder = '请选择' + row.label
					} else {
						placeholder = row.label
					}
				}
				return placeholder
			},
			// 绑定的相关事件
			handleEvent(item,e) {
				if(item.value == 'groupId'){
					this.fieldList.forEach((item2,index)=>{
						if(item2.value == 'groupId'){
							// let obj = item.options.find(node=>node.id==e)
							// if(obj){
							// 	this.fieldList[index + 1].options = this.fieldList[index + 1].options2.filter(item2=> item2.parentCode == obj.code)
							// }
						}
					})
				}
				if(item.value == 'name' && item.type == 'select2'){
					let item2 = item.options.find(item=>item.assetsId == e)
					this.data['code'] = item2.code
				}
				console.log(e)
				if(item.value == 'comAddress'){
					this.data['province'] = e[0]
					this.data['city'] = e[1]
					this.data['area'] = e[2]
				}
				if(item.value == 'assetsAddress'){
					this.data['assetsProvince'] = e[0]
					this.data['assetsCity'] = e[1]
					this.data['assetsArea'] = e[2]
				}
				if(item.value == 'lessorAddress'){
					this.data['lessorProvince'] = e[0]
					this.data['lessorCity'] = e[1]
					this.data['lessorArea'] = e[2]
				}
				// this.$emit('handleEvent', e)
			},
		},
		mounted() {
			this.cityInfo2.forEach(item=>{
				item.children.forEach(item2=>{
					delete item2.children
				})
			})
			this.cityInfo3 = this.cityInfo2
		}
	}
</script>

<style scoped lang="scss">
	.commonInfo-box {
		background: #fff;
		margin-bottom: 0.130208rem;

		.commonInfo-title {
			height: 0.208333rem;
			background: #F7F6F6;
			border-radius: 5px 5px 0px 0px;
			padding: 0 0.052083rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.title-des {
				padding-left: 0.052083rem;
				border-left: 2px solid #FACD00;
				height: 0.078125rem;
				font-size: 0.086rem;
			}

			.title-switch {
				cursor: pointer;
				width: 5px;
				height: 5px;
				border-top: 2px solid #bdbdbd;
				border-right: 2px solid #bdbdbd;
				transform: rotate(-45deg);
				margin-top: 4px;
				margin-right: 5px;
				transition: transform 0.5s;

				&.close {
					transform: rotate(135deg);
					margin-top: 0;
				}
			}
		}

		.commonInfo-list {
			padding: 0.125rem 0.104166rem 0.01rem;
			box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.3);
			border-radius: 0 0 5px 5px;
			display: flex;
			flex-wrap: wrap;

			.commonInfo-item {
				width: 100%;
				margin-right: .1rem;
				display: flex;
				align-items: center;
				margin-bottom: 20px;

				.commonInfo-des {
					width: 150px;
					text-align: right;
					margin-right: 10px;
				}
			}
		}
	}
</style>
